import styled from 'styled-components';

export const MappingFileUploadLayout = styled.div`
    owc-typography[variant='body1'] {
        color: var(--one-color-gray-600);
    }
`;

export const FileUploadedLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
